import {
  ImplementationDetail,
  ProviderConfig,
  Response as ClientResponse,
  Session,
} from '@finch-api/common/dist/internal/connect/validate';
import { ConnectError } from 'pages/Authorize/types';
import { Sandbox } from '@finch-api/common/dist/internal/connect/authorize';
import { SubmitOptions } from '../pages/Authorize/SignIn/SignIn';

export enum PayrollProviderId {
  AAP_ISOLVED = 'aap_isolved',
  ADP_RUN = 'adp_run',
  ADP_WORKFORCE_NOW = 'adp_workforce_now',
  ACCOUNTANTSWORLD = 'accountantsworld',
  AHOLA = 'ahola',
  ALPHASTAFF = 'alphastaff',
  AMCHECK = 'amcheck',
  APPLIED_BUSINESS_SOLUTIONS = 'applied_business_solutions',
  ASPEN_HR = 'aspenhr',
  BAMBOO_HR = 'bamboo_hr',
  BOB = 'bob',
  CERIDIAN_DAYFORCE = 'ceridian_dayforce',
  COADVANTAGE = 'coadvantage',
  COASTAL_PAYROLL = 'coastal_payroll',
  COMMON_SENSE_PAYROLL = 'common_sense_payroll',
  COUNTERPOINT_HCM = 'counterpoint_hcm',
  DEEL = 'deel',
  DOMINION_PAYROLL = 'dominion_payroll',
  ECCA = 'ecca',
  EMPLOYDRIVE = 'employdrive',
  EVERY_IO = 'every_io',
  FACTORIAL_HR = 'factorial_hr',
  FINCH = 'finch',
  GUSTO = 'gusto',
  HEARTLAND = 'heartland',
  HR_BUTLER = 'hr_butler',
  HUMAANS = 'humaans',
  HYBRID = 'hybrid',
  HORIZON_PAYROLL = 'horizonpayroll',
  IBUSINESS_SOLUTIONS = 'ibusiness_solutions',
  INSPERITY = 'insperity',
  INTEGRATED_PAYROLL_SERVICES = 'integrated_payroll_services',
  ISOLVED = 'isolved',
  JUSTWORKS = 'justworks',
  KABEL = 'kabel',
  LATTICE = 'lattice',
  LIFT_HCM = 'lift_hcm',
  MITER = 'miter',
  NAMELY = 'namely',
  OYSTER_HR = 'oyster_hr',
  ONPAY = 'onpay',
  PAYCHEX_FLEX = 'paychex_flex',
  PAYCOM = 'paycom',
  PAYCOR = 'paycor',
  PAYFLUENCE = 'payfluence',
  PAYLOCITY = 'paylocity',
  PAYDAY_PAYROLL = 'payday_payroll',
  PAYROLL_NETWORK = 'payroll_network',
  PAYROLL_SPECIALTIES = 'payroll_specialties',
  PAYROLL_VAULT = 'payroll_vault',
  PERSONIO = 'personio',
  PROXUS_HR = 'proxus_hr',
  QFORCE = 'qforce',
  QUICKBOOKS = 'quickbooks',
  REMOTE = 'remote',
  RIPPLING = 'rippling',
  SAGE_HR = 'sage_hr',
  SAPLING = 'sapling',
  SESAME = 'sesame',
  SEQUOIA_ONE = 'sequoia_one',
  SQUARE_PAYROLL = 'square_payroll',
  THREAD_HCM = 'thread_hcm',
  TRINET = 'trinet',
  UKG_READY = 'ukg_ready',
  ULTI_PRO = 'ulti_pro',
  WARP = 'warp',
  WAVE = 'wave',
  WORKDAY = 'workday',
  WORKFORCECOM = 'workforcecom',
  ZENEFITS = 'zenefits',
}

export interface RegisterProviderContainerProps {
  client: ClientResponse;
  provider: ProviderConfig;
  products: string[];
  hasBenefitsProduct: boolean;
  currentStep: string;
  implementationDetail: ImplementationDetail;
  children: React.ReactNode;
  sandboxMode: Sandbox;
  error: ConnectError | null;
  setError: (error: ConnectError | null) => void;
  connection?: Session['connection'];
}

// new implementation level props
export interface RegisterImplementationProps {
  client: ClientResponse;
  provider: ProviderConfig;
  implementationDetail: ImplementationDetail;
  isLoading: boolean;
  onSubmit: (fieldToValueMap: SubmitOptions) => Promise<void>;
  products: string[];
  handleClick?: () => void;
  sandboxMode: Sandbox;
  onMockOAuth: () => Promise<boolean>;
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
  instructionsInnerHtmlToScrollStep2?: string;
  instructionsInnerHtmlToScrollStep3?: string;
  instructionsInnerHtmlToScrollStep4?: string;
  instructionsInnerHtmlToScrollStep5?: string;
  instructionsInnerHtmlToScrollStep6?: string;
  instructionsInnerHtmlToScrollStep7?: string;
  instructionsInnerHtmlToScrollStep8?: string;
}

export class ClientBlockedError extends Error {
  clientName?: string;

  constructor(clientName?: string) {
    super('Client is blocked');
    this.clientName = clientName;
  }
}
